// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 3H6V7H18V3H21V11.6736C20.0907 11.2417 19.0736 11 18 11C14.134 11 11 14.134 11 18C11 19.9587 11.8045 21.7295 13.101 23H3V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5 18C12.5 14.9624 14.9624 12.5 18 12.5C21.0376 12.5 23.5 14.9624 23.5 18C23.5 21.0376 21.0376 23.5 18 23.5C14.9624 23.5 12.5 21.0376 12.5 18ZM20.4142 19.0001L19 17.5857V15.752H17V18.4141L18.9999 20.4142L20.4142 19.0001Z"}}]};

const TaskTimeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-time-filled',
    ref,
    icon: element,
  },
));

TaskTimeFilledIcon.displayName = 'TaskTimeFilledIcon';

export default TaskTimeFilledIcon;
